<template>
  <section class="tel" :aria-label="$t('teacherExtras.listTitle')">
    <header class="tel__head">
      <v-icon size="20" class="tel__icon">mdi-book-plus-outline</v-icon>
      <h2 class="tel__title">{{ $t("teacherExtras.listTitle") }}</h2>
      <span v-if="pending.length" class="tel__badge">
        {{
          $tc("teacherExtras.bannerPending", pending.length, {
            count: pending.length,
          })
        }}
      </span>
    </header>

    <ul v-if="shown.length" class="tel__list">
      <li v-for="item in shown" :key="item.id" class="tel__row">
        <div class="tel__main">
          <span class="tel__name">{{ item.title }}</span>
          <span class="tel__meta">
            {{ item.moduleTitle }}
            <template v-if="item.teacher">
              · {{ $t("teacherExtras.from", { name: item.teacher }) }}
            </template>
          </span>
        </div>
        <v-btn text small class="tel__open" @click="open(item)">
          {{ $t("teacherExtras.open") }}
          <v-icon right size="16">mdi-chevron-right</v-icon>
        </v-btn>
      </li>
    </ul>
    <p v-else class="tel__none">{{ $t("teacherExtras.listNone") }}</p>

    <router-link to="/connect/aluno/curso/indicados" class="tel__all">
      {{ $t("teacherExtras.listAll") }}
      <v-icon size="16" class="tel__all-icon">mdi-chevron-right</v-icon>
    </router-link>
  </section>
</template>

<script>
// Card 17trt6jfxtn (retorno de 30/10): a lista do que o professor indicou, logo
// abaixo do campo de busca da página do Curso. Mostra os que faltam ver; a
// página "Indicados pelo professor" traz todos (vistos e não vistos).
const MAX_SHOWN = 5;

export default {
  name: "TeacherExtrasList",

  props: {
    items: { type: Array, default: () => [] },
  },

  computed: {
    // Mais recente primeiro, como na página completa.
    pending() {
      return this.items
        .filter((item) => !item.viewed)
        .sort(
          (a, b) =>
            new Date(b.sharedAt).getTime() - new Date(a.sharedAt).getTime()
        );
    },
    shown() {
      return this.pending.slice(0, MAX_SHOWN);
    },
  },

  methods: {
    // Por path: o nome "Aulas" também pode existir na área do professor.
    open(item) {
      this.$router.push(`/connect/aluno/curso/${item.contentId}`);
    },
  },
};
</script>

<style scoped>
.tel {
  margin: 0 0 24px;
  padding: 16px 18px;
  border: 1px solid var(--dk-line, #ece6ef);
  border-radius: 14px;
  background: var(--dk-surface, #fff);
  font-family: "Poppins", sans-serif;
  color: var(--dk-ink, #231a2e);
}
.tel__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.tel__icon {
  flex: none;
  color: var(--dk-pink, #e8276f) !important;
}
.tel__title {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
}
.tel__badge {
  flex: none;
  padding: 2px 10px;
  border-radius: 999px;
  background: var(--dk-pink, #e8276f);
  font-size: 0.75rem;
  color: #fff;
}
.tel__list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.tel__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid var(--dk-line, #ece6ef);
}
.tel__main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}
.tel__name {
  font-size: 0.9rem;
  font-weight: 600;
}
.tel__meta {
  font-size: 0.78rem;
  color: var(--dk-muted, #6b6472);
}
.tel__open {
  flex: none;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
  color: var(--dk-pink, #e8276f) !important;
}
.tel__none {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: var(--dk-muted, #6b6472);
}
.tel__all {
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--dk-pink, #e8276f);
  text-decoration: none;
}
.tel__all-icon {
  color: inherit !important;
}
</style>
